import React from "react";

const StatusBar = ({ text, active }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "1rem",
      width: "100%",
    }}
  >
    <div
      style={{
        width: "0.5rem",
        height: "2rem",
        backgroundColor: active ? "green" : "red",
        transition: "background-color 0.2s",
      }}
    ></div>
    <p
      style={{
        fontSize: "1.15rem",
        fontWeight: "bold",
        color: "#000",
        display: "flex",
        alignItems: "center",
      }}
    >
      {text}
    </p>
  </div>
);

export default StatusBar;